import { useAds, Ad, SiteSections } from '@xing-com/crate-ads-native-ads';
import { AdTypes } from '@xing-com/crate-common-graphql-types';
import { GridContainer, Column } from '@xing-com/xing-grid';

import { Styled } from './ad-section.styles';

export const AdSection: React.FC = () => {
  const { ads, isCompleted } = useAds({
    adCount: 1,
    adTypes: [AdTypes.WebsiteAd, AdTypes.VideoAd],
    channel: 'login_logout_web_lo',
    isLoggedOut: true,
  });

  if (!isCompleted || !ads.length) {
    return null;
  }

  return (
    <Styled.Container>
      <GridContainer type="wide">
        <Styled.GridRow>
          <Column sizeWide={10} offsetWide={1} sizeConfined={12} size={12}>
            <Ad {...ads[0]} sectionId={SiteSections.Logout} isLoggedOut />
          </Column>
        </Styled.GridRow>
      </GridContainer>
    </Styled.Container>
  );
};
